import { render, staticRenderFns } from "./ComponentDetails.vue?vue&type=template&id=01fad735&scoped=true&"
import script from "./ComponentDetails.vue?vue&type=script&lang=js&"
export * from "./ComponentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDetails.vue?vue&type=style&index=0&id=01fad735&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fad735",
  null
  
)

export default component.exports